var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsPoint2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#FFF5F0",
    stroke: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.922 15.986C15.038 15.986 15.13 16.02 15.198 16.088C15.266 16.156 15.3 16.244 15.3 16.352V17H9.564V16.634C9.564 16.558 9.58 16.48 9.612 16.4C9.644 16.32 9.694 16.246 9.762 16.178L12.516 13.412C12.744 13.18 12.952 12.958 13.14 12.746C13.328 12.53 13.488 12.314 13.62 12.098C13.752 11.882 13.854 11.664 13.926 11.444C13.998 11.22 14.034 10.982 14.034 10.73C14.034 10.478 13.994 10.258 13.914 10.07C13.834 9.878 13.724 9.72 13.584 9.596C13.448 9.472 13.286 9.38 13.098 9.32C12.91 9.256 12.708 9.224 12.492 9.224C12.272 9.224 12.07 9.256 11.886 9.32C11.702 9.384 11.538 9.474 11.394 9.59C11.254 9.702 11.136 9.836 11.04 9.992C10.944 10.148 10.876 10.32 10.836 10.508C10.788 10.648 10.722 10.742 10.638 10.79C10.558 10.834 10.444 10.846 10.296 10.826L9.738 10.73C9.794 10.338 9.902 9.992 10.062 9.692C10.226 9.388 10.43 9.134 10.674 8.93C10.922 8.726 11.204 8.572 11.52 8.468C11.836 8.36 12.178 8.306 12.546 8.306C12.91 8.306 13.25 8.36 13.566 8.468C13.882 8.576 14.156 8.734 14.388 8.942C14.62 9.146 14.802 9.396 14.934 9.692C15.066 9.988 15.132 10.324 15.132 10.7C15.132 11.02 15.084 11.318 14.988 11.594C14.892 11.866 14.762 12.126 14.598 12.374C14.434 12.622 14.244 12.864 14.028 13.1C13.816 13.336 13.59 13.574 13.35 13.814L11.082 16.13C11.242 16.086 11.404 16.052 11.568 16.028C11.732 16 11.89 15.986 12.042 15.986H14.922Z",
    fill: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsPoint2);
export default __webpack_public_path__ + "static/media/WHSPoint2.193fefac4af4c31dbee7eef5d0146b55.svg";
export { ForwardRef as ReactComponent };